import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../services/api";

import "../styles/latestExams.css";

function LatestExams() {
  const [exams, setExams] = useState([]);

  useEffect(() => {
    fetchLatestExams();
  }, []);

  const fetchLatestExams = async () => {
    try {
      const response = await api.get("/exams");

      const latest = [...response.data]
        .sort(
          (a, b) =>
            new Date(b.created_at) -
            new Date(a.created_at)
        )
        .slice(0, 8);

      setExams(latest);

    } catch (error) {
      console.error(error);
    }
  };

  return (
    <section className="latest-section">

      <div className="section-header">

        <h2>Latest Uploads</h2>

        <p>
          Recently added examination papers.
        </p>

      </div>

      <div className="latest-grid">

        {exams.map((exam) => (

          <div
            className="latest-card"
            key={exam.id}
          >

            <div className="latest-content">

              <span className="latest-category">
                {exam.category}
              </span>

              <h3>
                {exam.title}
              </h3>

              <p>
                {exam.description
                  ? exam.description.substring(0, 80)
                  : "No description available."}
                ...
              </p>

              <div className="latest-footer">

                <span className="latest-price">

                  {exam.is_free
                    ? "FREE"
                    : `KES ${exam.price}`}

                </span>

                <Link
                  to={`/exam/${exam.id}`}
                  className="latest-btn"
                >
                  View Exam
                </Link>

              </div>

            </div>

          </div>

        ))}

      </div>

    </section>
  );
}

export default LatestExams;